import { useQuery, useMutation } from "@apollo/client";
import { ORGANIZATION_DASHBOARD, REFRESH_ORGANIZATION_STATS } from "../graphql";
import type { DashboardPeriod, OrganizationDashboardData } from "../types";

interface UseOrganizationDashboardOptions {
  organizationId: string;
  period: DashboardPeriod;
  skip?: boolean;
}

export function useOrganizationDashboard({
  organizationId,
  period,
  skip = false,
}: UseOrganizationDashboardOptions) {
  return useQuery<{
    organizationDashboard: OrganizationDashboardData;
  }>(ORGANIZATION_DASHBOARD, {
    variables: { organizationId, period },
    skip: skip || !organizationId,
    fetchPolicy: "cache-and-network",
  });
}

export function useRefreshOrganizationStats() {
  return useMutation<{ refreshOrganizationStats: boolean }>(
    REFRESH_ORGANIZATION_STATS,
    {
      refetchQueries: ["OrganizationDashboard"],
      awaitRefetchQueries: true,
    },
  );
}
